import { ContentType } from 'learning-panel-components';
import { coreService } from 'network-utils';

const convertLabToContentCard = (lab: coreService.LabContentCard) => {
    return {
        id: lab.id,
        type: 'lab' as keyof typeof ContentType,
        imageUrl: `${process.env.PUBLIC_URL}/images/labBackground.webp`,
        name: lab.name,
        description: lab.description,
        score: lab.potentialScore,
        status: lab.progress === 'started' ? 'inProgress' : lab.progress,
        displayName: lab.name,
        earnedPoints: lab.earnedScore,
        timeOrDate: String(lab.duration),
        cardUrl: `/app/lab/${lab.uuid}`,
        tags: lab.tags?.map(tag => tag.displayName)
    };
};

export default convertLabToContentCard;
